module.exports = __webpack_public_path__ + "media/images/proposal/top/reason2-141a81215ffc101d345173f1f6719f5b.jpg";